var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('section',[_c('h2',[_vm._v("Upcoming Events")]),(_vm.events)?_c('div',{attrs:{"id":"events"}},_vm._l((_vm.events),function(event){return _c('CalendarEntry',{key:event.id,attrs:{"event":event}})}),1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }